import React from "react";
import { useContext } from "react";

import { BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import Frontend from '../pages/Frontend'
import Authentication from "../pages/Authentication"
import Dashboard from '../pages/Dashboard'
import PrivateRoute from "../Components/PrivateRoute";
import { AuthContext } from "../context/AuthContext";

export default function Index() {

  const {isAuthenticated } =useContext(AuthContext)
  //console.log(user)
  
  return (
    <BrowserRouter>
<Routes>
    <Route path="/*" element={<Frontend/>}/>
   <Route path="/authentication/*" element={!isAuthenticated ? <Authentication/> : <Navigate to = "/dashboard"/> }/> 
    <Route path="/dashboard/*" element={<PrivateRoute Component={Dashboard}/>}/>

</Routes>
    </BrowserRouter>
  )
}
